(function () {
  'use strict';

  function normalize(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
      .replace(/<[^>]*>/g, ' ').replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
  }

  var generic = new Set(('kit kits gota dourada shampoo shampoos condicionador condicionadores mascara mascaras creme cremes ' +
    'tonico tonicos capilar capilares cabelo cabelos finalizador finalizadores leave in sem enxague tratamento tratamentos ' +
    'completo completa rotina produto produtos para com de da do das dos e o a os as no na ml kg gr g un unidades ' +
    'spray oleo locao fortalecedor fortalecedora fortalecimento linha anti frizz pentear combate queda crescimento ' +
    'body splash hidratante hidratacao nutricao embalagem frasco').split(' '));

  function familyTokens(title) {
    return Array.from(new Set(normalize(title).split(' ').filter(function (word) {
      return word.length >= 4 && !generic.has(word) && !/^\d/.test(word);
    })));
  }

  function lines(product) {
    var tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
    return tags.map(function (tag) {
      var match = String(tag).match(/^\s*linha\s*[:=_-]\s*(.+)$/i);
      return match ? normalize(match[1]) : '';
    }).filter(function (line) { return familyTokens(line).length > 0; });
  }

  function productKinds(value) {
    var words = normalize(value).split(' ');
    return ['shampoo', 'condicionador', 'mascara', 'tonico', 'creme', 'oleo', 'finalizador'].filter(function (kind) {
      return words.includes(kind) || words.includes(kind + 's') || (kind === 'tonico' && words.includes('tonicos'));
    });
  }

  function hasProductLink(description, handle) {
    if (!handle) return false;
    var anchors = String(description || '').matchAll(/<a\b[^>]*\bhref\s*=\s*["']([^"']+)["']/gi);
    for (var anchor of anchors) {
      var path = anchor[1].split(/[?#]/)[0].replace(/\/$/, '');
      if (path.toLowerCase().endsWith('/products/' + String(handle).toLowerCase())) return true;
    }
    return false;
  }

  function matchScore(source, kit) {
    if (String(source.product_id || source.id) === String(kit.id) ||
        !Array.isArray(kit.variants) || !kit.variants.some(function (v) { return v.available !== false && Number(v.price) > 0; })) return 0;
    var sourceLines = lines(source);
    var kitLines = lines(kit);
    var lineMatch = sourceLines.some(function (line) { return kitLines.includes(line); });
    if (sourceLines.length && kitLines.length && !lineMatch) return 0;
    var title = source.product_title || source.title;
    var childRange = /\b(infantil|clubinho|kids|bebe)\b/;
    if (childRange.test(normalize(title)) !== childRange.test(normalize(kit.title))) return 0;
    var tokens = familyTokens(title);
    var kitTokens = familyTokens(kit.title);
    var titleMatch = tokens.length > 0 && tokens.every(function (token) { return kitTokens.includes(token); });
    var linked = hasProductLink(kit.description, source.handle);
    // A shared broad range is not evidence that the individual belongs to this kit.
    var sharedTokens = familyTokens(sourceLines.filter(function (line) { return kitLines.includes(line); }).join(' '));
    var specificLineMatch = lineMatch && tokens.length > 0 && tokens.every(function (token) { return sharedTokens.includes(token); });
    if (!specificLineMatch && !titleMatch && !linked) return 0;
    var sourceKinds = productKinds(title);
    var kitKinds = productKinds(kit.title);
    if (!linked && sourceKinds.length && kitKinds.length && !sourceKinds.some(function (kind) {
      return kitKinds.includes(kind);
    })) return 0;
    var score = linked ? 1000 : specificLineMatch ? 600 : 200 + tokens.join('').length;
    var fullTitle = normalize(title).replace(/\bgota dourada\b/g, '').trim();
    if (fullTitle.length >= 8 && normalize(kit.description).includes(fullTitle)) score += 100;
    if (/\bcomplet[oa]\b/.test(normalize(kit.title))) score += 20;
    return score;
  }

  function findKit(source, kits) {
    return (kits || []).map(function (kit) { return { kit: kit, score: matchScore(source, kit) }; })
      .filter(function (entry) { return entry.score > 0; })
      .sort(function (a, b) {
        var cheapest = function (kit) { return Math.min.apply(Math, kit.variants.filter(function (v) {
          return v.available !== false && Number(v.price) > 0;
        }).map(function (v) { return Number(v.price); })); };
        return b.score - a.score || cheapest(a.kit) - cheapest(b.kit) || String(a.kit.id).localeCompare(String(b.kit.id));
      }).map(function (entry) { return entry.kit; })[0] || null;
  }

  window.GDKitMatching = { normalize: normalize, familyTokens: familyTokens, matchScore: matchScore, findKit: findKit };
})();
